<template>
  <div>
    <div class="
      col 
      w--50% 
      vh--100% 
      p--0px
    ">
      <div class="border-b--1px border-r--1px p--24px mb--20px">
        <h2 class="font--21px">site node tree</h2>
      </div>
      <div class="pr--20px">
        <ui-design-tree :components="row.components"></ui-design-tree>
      </div>
      <div class="text--right px--20px py--40px">
        <button
          class="btn btn--xl black text--white"
          type="button"
          @click="saveAll"
        >저장</button>
      </div>
    </div><!-- 컬럼끝 -->
    <div class="
      col 
      w--50% 
      vh--100%
      p--0px
      gray
      lighten-5
    ">
      <div class="gray lighten-5">
        <div class="border-b--1px p--24px white">
          <h2 class="font--21px">node info</h2>
        </div>
        <!-- <ui-design-attr-editor
          :component="node"
          v-if="node"
        ></ui-design-attr-editor> -->
        <div
          class="p--20px"
          v-if="copyed"
        >
          <div class="pb--16px">
            <label class="font--12px block pb--12px font--600">type</label>
            <form-input
              v-model="copyed.type"
              :error="error"
              name="type"
            ></form-input>
          </div>
          <div class="pb--16px">
            <label class="font--12px block pb--12px font--600">attrs</label>
            <form-textarea
              class="white"
              v-model="copyed.attrs"
              :error="error"
              name="attrs"
            ></form-textarea>
          </div>
          <div class="pb--16px">
            <label class="font--12px block pb--12px font--600">children</label>
            <form-textarea
              class="white"
              v-model="copyed.components"
              :error="error"
              name="components"
            ></form-textarea>
          </div>
        </div>
        <div class="text--right px--20px pb--40px">
          <button
            class="btn btn--xl black text--white"
            type="button"
            @click="save"
          >저장</button>
        </div>
      </div>
    </div><!-- 컬럼끝 -->
  </div>
</template>

<script>
import _ from 'lodash'

import boardEdit from './js/boardEdit'
import boardMeta from './js/boardMeta'
import theme from '@/component/js/theme'
import eventBus from '@/component/common/EventBus'

export default {
  mixins: [boardEdit, boardMeta, theme],
  data () {
    return {
      node: {},
      copyed: {}
    }
  },
  created () {
    eventBus.$on('select-tree-node', this.onSelectTreeNode)
  },
  methods: {
    onSelectTreeNode (node, component, e) {
      if (!node) {
        return
      }
      // node.attrs.extraClass = node.attrs.extraClass || ''

      // if (node.type === 'link') {
      //   if (!node.attrs.hasOwnProperty('seq') || !node.attrs.hasOwnProperty('key')) {
      //     node.attrs.key = ''
      //   }
      // } else if (node.type === 'text') {
      //   node.attrs.text = node.attrs.text || ''
      // } else if (node.type === 'container') {
      //   node.attrs.columns = node.attrs.columns || { desktop: 1, mobile: 1 }
      // }
      this.node = node

      const copyed = _.cloneDeep(node)
      if (copyed.type === 'link') {
        if (!copyed.attrs.hasOwnProperty('seq') || !copyed.attrs.hasOwnProperty('key')) {
          copyed.attrs.key = ''
        }
      } else if (copyed.type === 'text') {
        copyed.attrs.text = copyed.attrs.text || ''
      }

      if (copyed.attrs) {
        copyed.attrs = JSON.stringify(copyed.attrs, null, 2)
      }
      if (copyed.components) {
        copyed.components = JSON.stringify(copyed.components, null, 2)
      }

      this.copyed = copyed
    },
    async saveAll () {
      await this.$update(`/api/boards/${this.boardId}/seqs/${this.seq}`)
      console.log('save all!!!!')
    },
    async save () {
      // this.node = this.copyed
      if (this.copyed.attrs) {
        this.node.attrs = JSON.parse(this.copyed.attrs)
      }
      if (this.copyed.components) {
        this.node.components = JSON.parse(this.copyed.components)
      }

      const stringifyComponents = JSON.stringify(this.row.components, null, 2)
      // console.log('this.row.components', stringifyComponents, '---', this.stringifyComponents)
      if (this.row.components && stringifyComponents !== this.stringifyComponents) {
        // this.row.components = stringifyComponents
        await this.$update(`/api/boards/${this.boardId}/seqs/${this.seq}`)
        console.log('save!!!!')
      }
    }
  },
  components: {
    // UiDesignAttrEditor: () => import('./component/UIDesignAttrEditor'),
    UiDesignTree: () => import('./component/UIDesignTree'),
    FormInput: () => import('@/component/ui2/form/FormInput'),
    FormTextarea: () => import('@/component/ui2/form/FormTextarea')
  }
}
</script>
